<div class="title-components">
  <h1>Plantillas HOE</h1>
</div>

<!--&================== DIVIDER BUTONS LIBRARY ==================&-->
<div class="divider-butons-M">
  <button
    [class.Is-Disabled]="
      !UserService.UserRoleGeneralIn([
        RolesGeneral.AdministratorCCP,
        RolesGeneral.TemplatesCCP
      ])
    "
    [disabled]="
      !UserService.UserRoleGeneralIn([
        RolesGeneral.AdministratorCCP,
        RolesGeneral.TemplatesCCP
      ])
    "
    (click)="OpenModalIsUpdate(false, null)"
    class="btn-icon-text"
  >
    <i class="fa-solid fa-plus"></i><span class="text">Agregar Plantilla</span>
  </button>
</div>

<ng-container
  *ngIf="All_CCP_Templates.length > 0 && LoadPage; else Not_Template"
>
  <div class="Container-Card-Templates">
    <div class="card-wrap" *ngFor="let Template of All_CCP_Templates">
      <div class="card-header {{ Type_Extension_Class(Template.Extension) }}">
        <img
          src="./assets/Global/icon/{{
            Type_Extension_Img(Template.Extension)
          }}"
          alt=""
          srcset=""
        />
        <div
          *ngIf="
            UserService.UserRoleGeneralIn([
              RolesGeneral.AdministratorCCP,
              RolesGeneral.TemplatesCCP
            ])
          "
          class="Options-Template"
        >
          <button
            (click)="OpenModalIsUpdate(true, Template)"
            class="Btn-Option button-square Upload-M"
          >
            <i class="fa-solid fa-upload"></i>
          </button>
          <button
            (click)="Delete_Template(Template)"
            class="Btn-Option button-square Delete-M"
          >
            <i class="fa-regular fa-trash-can"></i>
          </button>
        </div>
      </div>
      <div class="card-content">
        <h1 class="card-title">{{ Cut_Name(Template.Name) }}</h1>
        <p class="card-text">
          Descargue la Plantilla presionando sobre el botón descargar
        </p>
        <button
          (click)="Download_Template(Template)"
          class="card-btn {{ Type_Extension_Class(Template.Extension) }}"
        >
          Descargar
        </button>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #Not_Template>
  <div class="Container-Preview container-global-components">
    <div class="Not-Template">
      <div class="Img-Not">
        <img src="./assets/Global/Ilustrations/Not-Annexes_See.png" alt="" />
      </div>
      <div class="Text-Not-Template">
        ¡Hola {{ NameUser() }}, aun no hay Plantillas para mostrar!
      </div>
    </div>
  </div>
</ng-template>

<!---===================== MODAL FOR ADD TemplateS =====================--->
<section class="Modal-Global" id="ModalAddTemplate">
  <div class="wrapper">
    <div class="Pro-popup3 popup" id="Pro-popup3">
      <div class="Pro-inside3 popup-inside" id="Pro-inside3">
        <div class="Pro-backgrounds3 backgrounds">
          <div class="background"></div>
          <div class="background background2"></div>
          <div class="background background3"></div>
          <div class="background background4"></div>
          <div class="background background5"></div>
          <div class="background background6"></div>
        </div>
      </div>
      <div class="Pro-content3 content" id="Pro-content3">
        <button (click)="ToggleModalAddTemplate(false)" class="Btn-Close">
          <i class="fa-solid fa-xmark"></i>
        </button>
        <div class="Content-Top">
          <h2>{{ !IsUpdate ? "Cargar" : "Actualizar" }} Template</h2>
        </div>

        <div class="Content-body">
          <div class="Container-Drop">
            <input
              #AddTemplate
              type="file"
              class="file"
              (dragover)="Load_File()"
              (dragleave)="Onload_File()"
              (change)="Load_Document_Template($event)"
            />
            <div class="Drag-Drop" id="Drag-Drop">
              <div class="Img">
                <img src="./assets/Global/Ilustrations/Add_Manual.png" alt="" />
              </div>
              <div class="Text">
                Suelte su archivo aquí, o
                <p>seleccione uno</p>
              </div>
              <div class="Subtitle">Soporta archivos PDF, PNG , PPTX ...</div>
            </div>
          </div>

          <div
            class="Container-Progress-Template"
            id="Container-Progress-Template"
          >
            <div class="Title-Progress-Template">
              <span>Cargando ...</span>
              <div id="Icon-Done" class="Icon-Done">
                <i class="fa-solid fa-check"></i>
              </div>
            </div>
            <div class="Container-Subtitle-Template">
              <div class="TextSubtitle">
                <span id="TextProgress">0%</span>- un momento por favor
              </div>
            </div>
            <div class="Container-Progress-Bar-Template">
              <div
                class="Progress-Bar-Template"
                id="Progress-Bar-Template"
              ></div>
            </div>
          </div>
        </div>
        <div class="Content-Bottom Modal-Template">
          <button
            (click)="ToggleModalAddTemplate(false)"
            class="Btn-LCancel-Form Btn-Close-Modal"
          >
            <span>Cerrar</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR DOWNLOAD PROGRESS BAR FIN =====================--->
<section class="Modal-Global" id="ProgressModal">
  <div class="Content-DownloadTable">
    <div class="Tittle-Table">
      <h2>Descargando Template ...</h2>
    </div>
    <div class="Body-Table">
      <div class="Container-progress-bar">
        <span class="Progress-Bar-Table" id="Progress-Bar-Table"></span>
      </div>
    </div>
  </div>
</section>

<!---===================== MODAL FOR LOADER COMPONENT =====================--->
<div class="Container-Loader-Global" id="Loader">
  <div class="loader loader-1">
    <div class="loader-outter"></div>
    <div class="loader-inner"></div>
  </div>
</div>
